import { RSAA } from 'redux-api-middleware';
import {
    CHECK_CUSTOMER_SPD_REQUEST,
    CHECK_CUSTOMER_SPD_SUCCESS,
    CHECK_CUSTOMER_SPD_FAILURE,
    UPDATE_CUSTOMER_SPD,
    UPDATE_CUSTOMER_SPD_FAILURE,
    UPDATE_CUSTOMER_SPD_REQUEST,
    UPDATE_CUSTOMER_SPD_SUCCESS,
    CUSTOMER_SPD_REQUEST,
    CUSTOMER_SPD_SUCCESS,
    CUSTOMER_SPD_FAILURE,
    CLICKED_SHOW_CUSTOMER_SPD,
    APPLY_CUSTOMER_CARD_SPD_CHANGES,
    APPLY_CUSTOMER_CARD_NON_SPD_CHANGES,
    CLEAR_CUSTOMER_SPD_ERROR,
    REMOVE_COBUYER_SPD
} from '../actionTypes/CustomerSpdTypes';
import { MANAGER_VIEW_APP_PREFIX, apiConfigHelper, locHrefUtil, offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';
import type { RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import type { CustomerSpd, StateTree } from '@makemydeal/dr-dash-types';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import * as offerReduxSelectors from '../selectors/offerRedux';

export const checkCustomerSpdRSAA = (commonConsumerId?: string) => {
    return (dispatch: any, getState: () => StateTree) => {
        const state = getState();

        const dealXgId = offerSessionUtils.getDealXgId();
        const locHref = locHrefUtil.getLocHref();
        const dealerId = String(dealerSelectors.getDealerId(state));
        const buyerCommonConsumerId = offerReduxSelectors.getShopperCommonConsumerId(state);
        const coBuyerCommonConsumerId = offerReduxSelectors.getCoBuyerCommonConsumerId(state);

        const basePath = `deal/${dealXgId}/checkcustomerspd`;
        const urlPath = commonConsumerId ? `${basePath}/${commonConsumerId}` : basePath;

        const commonConsumerIds = commonConsumerId
            ? [commonConsumerId]
            : [buyerCommonConsumerId, coBuyerCommonConsumerId].filter(Boolean);

        const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, urlPath);

        const request: RSAACallRequest = {
            endpoint: bffApiUrlResult.url,
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'x-dr-dealxgid': dealXgId, 'x-dr-dealerid': dealerId },
            types: [
                CHECK_CUSTOMER_SPD_REQUEST,
                {
                    type: CHECK_CUSTOMER_SPD_SUCCESS,
                    meta: { commonConsumerIds }
                },
                CHECK_CUSTOMER_SPD_FAILURE
            ],
            fetch: async (...args) => await fetch(...args)
        };
        dispatch({ [RSAA]: request });
    };
};

export const updateCustomerSpd = (commonConsumerId: string, customerSpdData: Omit<CustomerSpd, 'commonConsumerId'>) => {
    return {
        type: UPDATE_CUSTOMER_SPD,
        payload: { commonConsumerId, customerSpdData }
    };
};

export const applyCustomerCardSpdChanges = () => {
    return {
        type: APPLY_CUSTOMER_CARD_SPD_CHANGES
    };
};

export const applyCustomerCardNonSpdChanges = () => {
    return {
        type: APPLY_CUSTOMER_CARD_NON_SPD_CHANGES
    };
};

export const clickedShowCustomerSpd = () => {
    return {
        type: CLICKED_SHOW_CUSTOMER_SPD
    };
};

export const updateCustomerSpdRSAA = (customerSpdData: CustomerSpd[]) => {
    return (dispatch: any, getState: () => StateTree) => {
        const state = getState();

        const dealXgId = offerSessionUtils.getDealXgId();
        const locHref = locHrefUtil.getLocHref();
        const dealerId = String(dealerSelectors.getDealerId(state));

        const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, `saveCustomerSpd`);

        const request: RSAACallRequest = {
            endpoint: `${bffApiUrlResult.url}/${dealXgId}`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'x-dr-dealxgid': dealXgId, 'x-dr-dealerid': dealerId },
            body: JSON.stringify(customerSpdData),
            types: [
                {
                    type: UPDATE_CUSTOMER_SPD_REQUEST
                },
                {
                    type: UPDATE_CUSTOMER_SPD_SUCCESS,
                    meta: { customerSpdData }
                },
                {
                    type: UPDATE_CUSTOMER_SPD_FAILURE
                }
            ],
            fetch: async (...args) => await fetch(...args)
        };
        dispatch({ [RSAA]: request });
    };
};

export const customerSpdRSAA = (commonConsumerId: string) => {
    return (dispatch: any, getState: () => StateTree) => {
        const state = getState();

        const dealXgId = offerSessionUtils.getDealXgId();
        const locHref = locHrefUtil.getLocHref();
        const dealerId = String(dealerSelectors.getDealerId(state));

        const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(
            MANAGER_VIEW_APP_PREFIX,
            locHref,
            `deal/${dealXgId}/customerspd/${commonConsumerId}`
        );

        const request: RSAACallRequest = {
            endpoint: bffApiUrlResult.url,
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'x-dr-dealxgid': dealXgId, 'x-dr-dealerid': dealerId },
            types: [
                {
                    type: CUSTOMER_SPD_REQUEST,
                    meta: { commonConsumerId }
                },
                {
                    type: CUSTOMER_SPD_SUCCESS,
                    meta: { commonConsumerId }
                },
                {
                    type: CUSTOMER_SPD_FAILURE,
                    meta: { commonConsumerId }
                }
            ],
            fetch: async (...args) => await fetch(...args)
        };
        dispatch({ [RSAA]: request });
    };
};

export const clearCustomerSpdError = () => ({
    type: CLEAR_CUSTOMER_SPD_ERROR
});

export const removeCoBuyerSpd = (commonConsumerId: string) => ({
    type: REMOVE_COBUYER_SPD,
    payload: commonConsumerId
});
